import React, { useEffect } from 'react';
import CasestudiesBanner from './CasestudiesBanner';
import CasestudiesInnvoationscards from './CasestudiesInnvoationscards';
import CasestudiesCards from './CasestudiesCards';
import CasestudiesSecondcards from './CasestudiesSecondcards';
import CaseStudiesSectionpage from './CaseStudiesSectionpage';
import CasestudyContentPage from './CasestudyContentPage';
import CasestudyanimatedCards from './CasestudyanimatedCards';
import Casestudiesindustries from './Casestudiesindustries';
// import Casestudiesthridi from './Casestudiesthridi';
const CaseStudies = () => {
       useEffect(() => {
            window.scrollTo(0, 0);
          }, []); // Empty dependency array ensures it only runs once when the component mounts
                  // Scroll to the top of the page when the component mounts
                  
         
    return (
        <div style={{ backgroundColor: '#fff' }}>
            <CasestudiesBanner />
            <CasestudyContentPage /> <br></br><br></br>
            <CaseStudiesSectionpage />
            <CasestudiesCards />
            <CasestudiesSecondcards />
            <Casestudiesindustries />
            {/* <Casestudiesthridi /> */}
            {/* <CasestudyanimatedCards /> */}
            
        </div>
    );
};

export default CaseStudies;
